var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history"},[_c('v-base-card',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_vm._v(" ユーザー(教室)情報 "+_vm._s(_vm.title)+" ")]},proxy:true},{key:"content",fn:function(){return [_c('v-account-form',{on:{"submit":_vm.submit}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }